import { Skeleton } from '@/components/ui/skeleton'

export const DatabaseTypeFallback = () => (
  <>
    <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
      <Skeleton className="h-22 w-full" />
      <Skeleton className="h-22 w-full" />
      <Skeleton className="h-22 w-full" />
      <Skeleton className="h-22 w-full" />
      <Skeleton className="h-22 w-full" />
    </div>
  </>
)
